import { sum } from 'utils/calculator';
import * as R from 'ramda';

export const capitalize = R.compose(R.join(''), R.juxt([R.compose(R.toUpper, R.head), R.tail]));

export const removeLeadingZeros = R.dropWhile(R.equals('0'));

export const removeEmptyValues = R.pickBy(R.compose(R.not, R.isNil));

export const isIncludedIn = R.flip(R.includes);

export const startCase = R.compose(R.join(''), R.over(R.lensIndex(0), R.toUpper));

export const formatProductFamilyName = (name) => {
  if (!name) return '';

  return name
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

const notNil = R.compose(R.not, R.isNil);

export const findProp = (property) => R.pipe(R.find(R.both(notNil, R.has(property))), R.prop(property));

export const nonEmptyIntersection = R.curry(R.compose(R.not, R.isEmpty, R.intersection));

export const findAndReplace = R.curry((test, newObject, list) => {
  const index = R.findIndex(test, list);

  if (index > -1) {
    return R.update(index, R.mergeDeepRight(list[index], newObject), list);
  }

  return list;
});

export const getSubstrings = (name) => {
  const match = name.match(/(.*?)\s(.*)/);

  if (match) {
    return [name.toLowerCase(), ...getSubstrings(match[2])];
  }

  return [name.toLowerCase()];
};

/* From Ramda cookbook https://github.com/ramda/ramda/wiki/Cookbook#rename-keys-of-an-object */
export const renameKeys = R.curry((keysMap, obj) => R.reduce((acc, key) => R.assoc(keysMap[key] || key, obj[key], acc), {}, R.keys(obj)));

export const mapObject = (callback, obj) => Object.keys(obj).map((key) => callback(key, obj[key]));

export const transformAllValues = R.curry((func, obj) =>
  R.keys(obj).reduce(
    (acc, key) => ({
      ...acc,
      [key]: func(obj[key])
    }),
    {}
  )
);

export const calcSegmentPointsTotal = (segments) =>
  segments &&
  segments.reduce((acc, segment) => {
    const points = segment.products.map((product) => product.loyaltyPoints);

    return sum([acc, ...points]);
  }, 0);
